import { Outlet, Link } from 'react-router-dom'
import { Brand } from '../../components/common/Brand'
export function AuthLayout() {
  return (
    <main id="main-content" className="auth-layout">
      <section className="auth-intro">
        <Brand variant="horizontal" tone="reversed" />
        <div>
          <p className="auth-intro__title">Kembali terhubung dengan komuniti anda.</p>
          <p>Profil disahkan, privasi terkawal dan carian alumni dalam satu ruang rasmi.</p>
        </div>
        <Link to="/">Kembali ke halaman utama</Link>
      </section>
      <section className="auth-panel">
        <Outlet />
      </section>
    </main>
  )
}
